import React from 'react';

// Context to provide media (images/videos) to MDX components
export const MdxMediaContext = React.createContext({
  images: {},
  videos: {}
});

export const MdxMediaProvider = MdxMediaContext.Provider;

export const useMdxMedia = () => React.useContext(MdxMediaContext);

